import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'
import type { UiMode } from '@/lib/ui-mode'

type Ctx = { mode: UiMode; advanced: boolean; setMode: (next: UiMode) => void }
const UiModeContext = createContext<Ctx>({ mode: 'SIMPLE', advanced: false, setMode: () => {} })

/** Per person, optimistic: the toggle feels instant and a failed write reverts on the next load. */
export function UiModeProvider({ initial, children }: { initial: UiMode; children: ReactNode }) {
  const [mode, setModeState] = useState<UiMode>(initial)
  const setMode = useCallback((next: UiMode) => {
    setModeState(next)
    void fetch('/api/me', { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ uiMode: next }) }).catch(() => {})
  }, [])
  return <UiModeContext.Provider value={{ mode, advanced: mode === 'ADVANCED', setMode }}>{children}</UiModeContext.Provider>
}

export function useUiMode(): Ctx {
  return useContext(UiModeContext)
}
